import React from 'react';
import axios from 'axios';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { Grid } from 'antd-mobile';
import AppHeader from './AppHeader';
import { sealCheckout } from '../../utils/secureCheckout';

// Customer lands here from the staff-issued reset link:
//   /more/set-new-password?token=XXXX
// They set a new password (new + confirm), authenticated by the token.
class SetNewPasswordPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            step: "password",
            message: "",
            show_hide: false,
            token: "",
            form: { password: '', re_new_password: '' }
        };
        this.changePasswordApi = this.changePasswordApi.bind(this);
        this.showHide = this.showHide.bind(this);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        // Read ?token= from the URL
        let token = "";
        try {
            let params = new URLSearchParams(this.props.location.search);
            token = params.get('token') || "";
        } catch (e) {
            token = "";
        }
        if (!token) {
            this.setState({ message: "ဤလင့်ခ်သည် မှားယွင်းနေပါသည်။", step: "error" });
        } else {
            this.setState({ token });
        }
    }

    showHide() {
        this.setState({ show_hide: !this.state.show_hide });
    }

    inputChangeHandler(e) {
        let form = { ...this.state.form };
        form[e.target.name] = e.target.value;
        this.setState({ form });
    }

    changePasswordApi() {
        if (this.state.form.password !== this.state.form.re_new_password) {
            this.setState({ message: "စကားဝှက် နှစ်ခု ကိုက်ညီမှု မရှိပါ" });
            return;
        }
        if (this.state.form.password.length < 6) {
            this.setState({ message: "စကားဝှက်မှာအနည်းဆုံးအက္ခရာ ၆ လုံးရှိရမည်" });
            return;
        }

        let formdata = {
            token: this.state.token,
            password: this.state.form.password,
            re_new_password: this.state.form.re_new_password
        };
        var self = this;
        let dataurl = window.BPdata.apiUrlCMSV2 + '/player/set-password-by-token';
        axios({
            method: 'post',
            url: dataurl,
            data: sealCheckout(formdata),
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "X-Trident-Token": window.BPdata.token,
                "BP-Agent": window.BPdata.rand_compound
            },
        })
        .then(function (response) {
            if (response.data.data.status == 200) {
                localStorage.setItem(window.BPdata.time, response.data.data.token);
                localStorage.setItem('username', response.data.data.username);
                self.setState({ message: response.data.data.message, step: "profile" });
                self.props.history.push("/");
            } else {
                self.setState({ message: response.data.data.message });
            }
        })
        .catch(function (error) {
            // console.log(error);
        });
    }

    passwordBlock() {
        return <div>
            <div className="row page-contest">
                <div className="grid-90 grid-s-90 left">
                    <div className="form-group text-left">
                        <label className="passLine">{window.lang.form.new_password}</label>
                        <small style={{ display: 'block', opacity: 0.7, fontSize: '0.72rem', lineHeight: '1.35', marginTop: '4px' }}>{window.lang.auth.password_rules}</small>
                    </div>
                </div>
                <div className="grid-90 grid-s-90 left">
                    <div className="form-group text-center" style={{ position: 'relative' }}>
                        <input
                            type={this.state.show_hide ? 'text' : 'password'}
                            className="form-control text-left" value={this.state.form.password} name="password" onChange={(e) => this.inputChangeHandler.call(this, e)} placeholder={window.lang.form.new_password}
                        />
                        <span className='changePwd' onClick={this.showHide}
                            style={{ position: 'absolute', right: '20px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer', color: 'black' }}>
                            {this.state.show_hide ? <FaEye className='iconColor' style={{ color: 'black' }} /> : <FaEyeSlash style={{ color: '' }} />}
                        </span>
                    </div>
                    <div className="form-group text-left mt-20">
                        <label className="passLine">{window.lang.form.re_new_password}</label>
                    </div>
                    <div className="form-group text-center" style={{ position: 'relative' }}>
                        <input
                            type={this.state.show_hide ? 'text' : 'password'}
                            className="form-control text-left" value={this.state.form.re_new_password} name="re_new_password" onChange={(e) => this.inputChangeHandler.call(this, e)} placeholder={window.lang.form.re_new_password}
                        />
                        <span className='changePwd' onClick={this.showHide}
                            style={{ position: 'absolute', right: '20px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer', color: 'black' }}>
                            {this.state.show_hide ? <FaEye className='iconColor' style={{ color: 'black' }} /> : <FaEyeSlash style={{ color: '' }} />}
                        </span>
                    </div>
                    <br />
                    <p className="color-red" style={{ fontSize: '0.8rem', lineHeight: 1.9, textAlign: 'left', margin: '22px 0' }}>
                        ငွေလိမ်လည်မှုမှကာကွယ်ရန် သင်၏ စကား၀ှက် ကိုမည်သူနှင့်မျှမပြောပြပါနှင့်။<br />
                        ဝန်ဆောင််မှုဝန်ထမ်းလည်း သင်၏ စကား၀ှက် ကိုမေးခွင့်လုံးဝမရှိပါ။ မေးခဲ့ပါက အတုအယောင်များသာဖြစ်ပါသည်။
                    </p>
                    <input type="submit" className="btn btn-yellow   pointer grid-50" value={window.lang.form.submit} onClick={this.changePasswordApi} /><br />
                </div>
            </div>
        </div>
    }

    profileBlock() {
        return <div>
            <div className="row">
                <br />
                <h2>Mingalarpar {localStorage.getItem('username')}</h2>
                <p>Welcome to ThaHtayLay</p>
                <br />
                <img src="/img/logo.png" className="medium-logo" />
            </div>
        </div>
    }

    viewHandler() {
        switch (this.state.step) {
            case "password": return this.passwordBlock();
            case "profile": return this.profileBlock();
            default: return "";
        }
    }

    render() {
        return (
            <div className="page">
                <div className="page-content text-center">
                    <AppHeader titleType="2" title={window.lang.form.password_reset} isLoading="false" />
                    <div className="main-content">
                        <br /><br />
                        <h1 className="color-theme-gold">{window.lang.form.password_reset}</h1>
                        <br />
                        <span>{this.state.message}</span>
                        {this.viewHandler()}
                    </div>
                </div>
                <footer className="App-footer">
                    <div className="App-footer-inner">
                        <Grid data={window.lang.footer}
                            columnNum={5}
                            renderItem={dataItem => (
                                <Link to={dataItem.url} className="cont-wrap-link hvr-pulse-shrink" style={{ width: '100%' }}>
                                    <span className="text-white"><img src={dataItem.icon} height="25px" /><br />{dataItem.text} </span>
                                </Link>
                            )}
                        />
                    </div>
                </footer>
            </div>
        );
    }
}

export default SetNewPasswordPage;
